import React from 'react'
import { URL_CTRL_HIDRIC } from '../router/Url';

export const GetLastData = (planta) => {
  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_CTRL_HIDRIC+'lastdatainsert',{
      method: 'POST',
      headers: {
        'authorization': "marcuxo",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        empresa: planta
      })
    })
    let responsito = await query.json();
    // console.log(responsito)
    if(responsito.success){
      resolve(responsito.body)
    }else{
      resolve(responsito)
    }
  })
}
